import React from 'react';
import { FormattedText } from 'core/i18n';
import { translations } from './constants';
import './VulnerablyOlderAdvise.scss';

const VulnerablyOlderAdvise = ({ visibility, onClick }) =>
    visibility && (
        <div className="vulnerably-older">
            <div className="prospects-gutter prospects-separator">
                <div className="row">
                    <div className="col-xs-12">
                        <i className="icons icons--icon-handshake icons--icon-handshake__black" />
                        <h5 className="font-heading5 vulnerably-older__title">
                            <FormattedText value={translations.TITLE} />
                        </h5>
                        <span className="dash" />
                        <p className="font-paragraph2 vulnerably-older__description">
                            <FormattedText value={translations.DESCRIPTION} />
                        </p>
                        <div>
                            <i className="icons icons--icon-phone-blue"></i>
                            <p className="font-paragraph2 vulnerably-older__call-center">
                                <FormattedText value="initial-contactMessage" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form__footer form__footer-inner">
                <div className="text-right">
                    <button type="button" className="form__button form__button-secondary" onClick={onClick}>
                        <FormattedText value="button-understood" />
                    </button>
                </div>
            </div>
        </div>
    );

export default VulnerablyOlderAdvise;
